module.exports = __webpack_public_path__ + "assets/img/1008.95704418.png";